module.exports = "<section class=\"container-fluid with-maxwidth chapter\">\r\n    <my-materials-consult-delete></my-materials-consult-delete>\r\n</section>"


//////////////////
// WEBPACK FOOTER
// ./src/app/materiales/materiales.component.html
// module id = ./src/app/materiales/materiales.component.html
// module chunks = main